import createIcon from '../../createIcon';

/**
 * @component @name PhotoSizeSelectActual
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgM0gzQzIgMyAxIDQgMSA1VjE5QzEgMjAuMSAxLjkgMjEgMyAyMUgyMUMyMiAyMSAyMyAyMCAyMyAxOVY1QzIzIDQgMjIgMyAyMSAzWk01IDE3TDguNSAxMi41TDExIDE1LjUxTDE0LjUgMTFMMTkgMTdINVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PhotoSizeSelectActual = createIcon('PhotoSizeSelectActual', [
  [
    'path',
    {
      d: 'M21 3H3C2 3 1 4 1 5V19C1 20.1 1.9 21 3 21H21C22 21 23 20 23 19V5C23 4 22 3 21 3ZM5 17L8.5 12.5L11 15.51L14.5 11L19 17H5Z',
      key: '1ub819',
    },
  ],
]);

export default PhotoSizeSelectActual;
